var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlinedDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#FF4820",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C6.41015 4 3.5 6.91015 3.5 10.5C3.5 14.0899 6.41015 17 10 17C13.5899 17 16.5 14.0899 16.5 10.5C16.5 6.91015 13.5899 4 10 4ZM2 10.5C2 6.08172 5.58172 2.5 10 2.5C14.4183 2.5 18 6.08172 18 10.5C18 14.9183 14.4183 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6778 14.1316C10.6702 14.1399 10.6623 14.1481 10.6543 14.1561L10.5292 14.2809C10.236 14.5735 9.76111 14.573 9.46855 14.2797L9.3439 14.1548C9.33628 14.1472 9.32882 14.1394 9.32153 14.1314L6.63472 11.1954L6.46969 11.0303C6.1768 10.7374 6.1768 10.2626 6.46969 9.96967C6.76258 9.67677 7.23745 9.67677 7.53035 9.96967L7.70712 10.1464C7.71496 10.1543 7.72261 10.1623 7.73009 10.1704L9.24953 11.8308L9.24976 7.24984C9.24985 6.83562 9.58571 6.49991 9.99993 6.5C10.4141 6.5001 10.7499 6.83596 10.7498 7.25017L10.7495 11.8316L12.27 10.1704C12.2774 10.1622 12.2851 10.1543 12.2929 10.1464L12.4697 9.96967C12.7626 9.67678 13.2374 9.67678 13.5303 9.96967C13.8232 10.2626 13.8232 10.7374 13.5303 11.0303L13.3653 11.1954L10.6778 14.1316Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedDown);
export default __webpack_public_path__ + "static/media/outlined-down.2d61872b.svg";
export { ForwardRef as ReactComponent };